import React from 'react';

import {
  DateTitle,
  DateWrapper,
  StatusContainer,
  StatusTitle,
  TextField,
} from '@components/detail-panel/components/EventStatusCard/styled';
import {
  IEventStatusCard,
  TStatusCardKit,
} from '@components/detail-panel/components/EventStatusCard/typed';
import { EEventManagementTabsType } from '@src/common/constant/enum';
import { formatStatus, formatTimestamp } from '@src/emp-3.0/utils';
import StatusTag from '@src/emp-3.0/components/common/StatusTag';
import { isDeployed } from '@src/emp-3.0/utils/checks';

const mappingTable = {
  'Create Date': 'created_at',
  'Last Update': 'updated_at',
  'Deploy Date': 'deployed_at',
  'Blocked Date': 'block_timestamp',
  'Blocked By': 'block_by',
};

const EventStatusCard: React.FC<IEventStatusCard> = ({
  type = EEventManagementTabsType.MAPPED_EVENT,
  blockEvent,
  mappedEvent,
  customDimension,
}) => {
  const StatusCardKit: TStatusCardKit = {
    [EEventManagementTabsType.MAPPED_EVENT]: {
      event: mappedEvent,
      statusCategory: 'Status',
      state: formatStatus(mappedEvent?.status),
      recordDateInfo: ['Create Date', 'Last Update', 'Deploy Date'],
      recordOperatorInfo: [],
    },
    [EEventManagementTabsType.BLOCKED_EVENT]: {
      event: blockEvent,
      recordDateInfo: ['Blocked Date'],
      recordOperatorInfo: ['Blocked By'],
    },
    [EEventManagementTabsType.METRICS]: {
      statusCategory: 'Category Type',
      state: 'Custom',
      recordDateInfo: ['Create Date'],
      recordOperatorInfo: ['Create By'],
    },
    [EEventManagementTabsType.CUSTOM_DIMENSION]: {
      event: customDimension,
      statusCategory: 'Status',
      state: formatStatus(customDimension?.status),
      recordDateInfo: ['Create Date', 'Last Update', 'Deploy Date'],
    },
  };

  const {
    event,
    statusCategory,
    state,
    recordDateInfo = [],
    recordOperatorInfo = [],
  } = StatusCardKit[type];

  return (
    <div>
      <StatusContainer>
        {statusCategory && <StatusTitle>{statusCategory}:</StatusTitle>}
        {state && (
          <StatusTag
            size="large"
            type="light"
            typeColor="blue"
            style={{
              background: '#e9f3fd',
            }}
          >
            {state}
          </StatusTag>
        )}
      </StatusContainer>
      <div>
        {recordDateInfo?.map((item) => {
          const timestamp = event?.[mappingTable[item]];
          const text = typeof timestamp === 'string' ? timestamp : formatTimestamp(timestamp);
          return (
            <DateWrapper key={item}>
              <DateTitle>{item}：</DateTitle>
              <TextField>{text}</TextField>
            </DateWrapper>
          );
        })}
        {recordOperatorInfo?.map((item) => {
          return (
            <DateWrapper key={item}>
              <DateTitle>{item}：</DateTitle>
              <TextField style={{ color: 'rgba(0,0,0,0.88)' }}>
                {event?.[mappingTable[item]]}
              </TextField>
            </DateWrapper>
          );
        })}
      </div>
    </div>
  );
};

export default EventStatusCard;
